module.exports = __webpack_public_path__ + "img/csesoc-logo-white.0ad99c74.svg";